import { Badge } from '@mantine/core';

type StatusBageProps = {
  isActive: boolean;
};

export const StatusBage = ({ isActive }: StatusBageProps) =>
  isActive ? (
    <Badge variant='light-skill' color='green'>
      Активен
    </Badge>
  ) : (
    <Badge variant='light-skill' color='red'>
      Неактивен
    </Badge>
  );
